angular.module 'zc.core'

.directive 'fixedOnScroll', ($document) ->
  restrict: 'A'

  link: (scope, element, attrs) ->
    DEFAULT_OFFSET = 10
    try
      if attrs.offsetTop
        offsetTop = parseInt(attrs.offsetTop)
      else
        offsetTop = DEFAULT_OFFSET
    catch
      offsetTop = DEFAULT_OFFSET
      
    el = angular.element(element)
    offset = el.offset()
    initialPosition = el.css('position') || "static"

    handleScroll = (ev) ->
      scrollTop = $document.scrollTop()
      if scrollTop > offset.top - offsetTop
        el.css('position', 'fixed')
        #el.css('left', offset.left)
        el.css('top', offsetTop)
      else
        el.css('position', initialPosition)

    $document.on 'scroll', handleScroll

    scope.$on '$destroy', () ->
      $document.off 'scroll', handleScroll



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/fixed-on-scroll.directive.coffee